import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPParameterTypeDataDDL } from '../../../../../../Components/CommonDDL/STPParameterTypeDDL';
import { STPQualityParameterPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPMaster/STPQualityParameterSlice';


export default function STPMasterQualityParameterDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [ParameterType, setParameterType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_IndicatorParameterTypeID : 0,
        Label: Flag === 'Update' ? rowData.indicatorName : "Select...",
    })

    const [QualityParameterName, setQualityParameterName] = useState(Flag === 'Update' ? rowData.qualityParameterName : '')


    const handlePost = () => {
        const data = {
            M_STP_QualityParameterID: Flag === 'Update' ? rowData.m_stP_QualityParameterID : '0',
            M_IndicatorParameterTypeID: ParameterType.ID,
            QualityParameterName: QualityParameterName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPQualityParameterPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Quality Parameter</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <STPParameterTypeDataDDL
                                        ParameterType={ParameterType}
                                        setParameterType={setParameterType}
                                    // WardName={WardName}
                                    // IsPost={IsPost}
                                    // Flag='ward'
                                    />

                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Quality Parameter Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="QualityParameterName"
                                            value={QualityParameterName}
                                            onChange={(e) => setQualityParameterName(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-4 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    onClick={() => handlePost()}
                                    disabled={
                                        ParameterType.ID == 0 || QualityParameterName == '' 
                                    }

                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}